import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useGetFicheHebergementQuery } from '../services/ReservationAPI';
import { type BlocksContent, BlocksRenderer } from "@strapi/blocks-react-renderer";
import ReservationStyle from '../styles/pages/FicheHebergement.module.scss';
import arrowLeft from '../shared/images/icon-arrow-left.svg'

const FicheHebergementPage: React.FC = () => {
    const { ressourceTypeCode } = useParams<{ ressourceTypeCode: string }>();
    const { bookingId } = useParams<{ bookingId: string }>();
    const {
        data: FicheHebergementData,
        refetch
      } = useGetFicheHebergementQuery(ressourceTypeCode || "");

      // Définir explicitement le type de l'état local
        const [ficheHebergementDetails, setFicheHebergementDetails] = useState<{
            title: string;
            description: BlocksContent;
            imageUrl: string;
            heure_arrivee: string;
            heure_depart: string;
        }>({
            title: '',
            description: [],
            imageUrl: '',
            heure_arrivee: '',
            heure_depart: ''
        });

        // Mettre à jour l'état local dès que animationData est disponible
            useEffect(() => {
                if (FicheHebergementData) {
                    setFicheHebergementDetails({
                        title: FicheHebergementData.title,
                        description: FicheHebergementData.description,
                        imageUrl: FicheHebergementData.imageUrl,
                        heure_arrivee: FicheHebergementData.heure_arrivee,
                        heure_depart: FicheHebergementData.heure_depart
                    });
                }
            }, [FicheHebergementData]);

      useEffect(() => {
          refetch(); // Rafraîchir les données lorsque la page est visitée
        }, [refetch]);
      
        useEffect(() => {
          console.log("FicheHebergementData  ====>");
          console.log(FicheHebergementData)
        }, [FicheHebergementData]);

        return (
            <>
            <div className={ReservationStyle.MainContainer}>
                <div className={ReservationStyle.TopContainer}>
                    <Link to={`/booking/${bookingId}`}>
                        <button className={ReservationStyle.arrowButton}>
                            <img src={arrowLeft} alt='Arrow Left' />
                        </button>
                    </Link>
                </div>
    
            <div className={ReservationStyle.AnimationContainer}>
                <h2>{ficheHebergementDetails.title}</h2>
                <img
                    src={`${process.env.REACT_APP_BASE_URL}${ficheHebergementDetails.imageUrl}` || 'default-image.png'}
                    alt={ficheHebergementDetails.title}
                />
                <div className={ReservationStyle.description}>
                <BlocksRenderer content={ficheHebergementDetails.description} /></div>
            </div>
                </div>
                </>
        );
}

export default FicheHebergementPage